"use client";

import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import { useRouter } from "next/navigation";

export default function SplashScreen() {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            background:
              "radial-gradient(ellipse at bottom, rgb(0, 0, 0) 0%, #68ff1620 100%)",
          }}
        >
          {/* Star layers */}
          <div className="splash-stars"></div>
          <div className="splash-stars2"></div>
          <div className="splash-stars3"></div>

          {/* Logo with shine */}
          <div
            style={{ position: "relative", marginBottom: "2rem", zIndex: 2 }}
          >
            <video
              src="/trq_liquid.webm"
              onClick={() => router.push("/")}
              height={360}
              width={360}
              autoPlay
              loop
              muted
              playsInline
              className="center cursor-pointer"
              style={{ paddingLeft: "3px" }}
            />

            {/* <motion.div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(120deg, transparent 20%, rgba(255,255,255,0.5) 50%, transparent 80%)",
                mixBlendMode: "overlay",
              }}
              initial={{ x: "-100%" }}
              animate={{ x: "100%" }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "loop",
              }}
            /> */}
          </div>

          {/* Title beneath logo */}
          <motion.div
            className="splash-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 1 }}
          >
            <div className="flex">
              <span>WE WILL HIJACK YOUR MIND</span>
            </div>
          </motion.div>

          {/* Loading bar */}
          <div
            style={{
              width: "16rem",
              height: "0.5rem",
              backgroundColor: "rgba(255,255,255,0.2)",
              borderRadius: "9999px",
              overflow: "hidden",
              marginTop: "1.5rem",
              zIndex: 2,
            }}
          >
            <motion.div
              style={{
                height: "100%",
                backgroundColor: "white",
                borderRadius: "9999px",
              }}
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 2.5, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
